var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineSegment = function SvgIconLineSegment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.75 6a3.25 3.25 0 1 1 1.77 2.894L8.894 16.52a3.25 3.25 0 1 1-1.414-1.414l7.626-7.626A3.24 3.24 0 0 1 14.75 6M18 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-12 12a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconLineSegment;